<template>
  <div class="oracle-agile">
    <s-r-m-header ref="header" activeVal='oracleAgile' />
    <carousel-container ref="carouselContainer" :carouselInfo="carouselInfo" />
    <OracleDesc></OracleDesc>
    <ValueGain
      title="Oracle Agile PLM能带来什么价值收益？"
      description="根据对众多Oracle Agile PLM客户调查研究的结果，Oracle Agile PLM通常能为企业带来以下价值收益"
      :caseList="[
        {
          mark: '减少',
          img: require('@/assets/images/sy1.png'),
          scope: '30-50',
          desc: '多余和过期库存'
        },
        {
          mark: '降低',
          img: require('@/assets/images/sy2.png'),
          scope: '3-5',
          desc: '直接物料成本降低'
        },
        {
          mark: '减少',
          img: require('@/assets/images/sy3.png'),
          scope: '25-50',
          desc: '报废和返工成本'
        },
        {
          mark: '加快',
          img: require('@/assets/images/sy4.png'),
          scope: '50',
          desc: '产品量产准备速度'
        }
      ]"
    ></ValueGain>
    <ProblemSolving
      title='Oracle Agile PLM能解决哪些问题？'
      description='Oracle Agile PLM可以有效解决产品研发管理中的核心痛点，包括数据管控和安全、任务执行、项目监督以及标准化流程管理等方面的问题'
    ></ProblemSolving>
    <SystemFunction
      :systemInfo="systemInfo"
    ></SystemFunction>
    <TabManagement
      title="1、协同研发管理平台"
      description="Agile Product Portfolio Management在整个产品生命周期管理产品组合、项目和产品信息。该方案使组织能衡量时间、成本、以及过去类似项目组合财务绩效等指标，以优化资源配置、产品投资和项目执行决策。"
      :tabList="tabList1"
    ></TabManagement>
    <TabManagement
      isLeft
      title="2、统一产品数据平台"
      description="Agile Product Collaboration 管理的产品信息包括：物料清单，文档，工程和制造变更，配置，以及机械、电子和软件数据库。该方案能为企业增强信息的可见性，帮助企业实现内外部设计、供应和制造数据的无缝集成，并跨扩展的供应链实现产品记录信息和流程的管理和协同。"
      :tabList="tabList2"
    ></TabManagement>
    <TabManagement
      title="3、研发质量管理平台"
      description="Agile Product Quality Management 提供一个协作式环境来跟踪和整合产品记录中与产品质量有关的信息。使产品质量信息和质量问题在从产品开发到产品寿命终结的整个产品生命周期内对所有相关方都是可视的，这能够确保形成一种关注产品质量的企业文化。企业可以无缝地发现和分析报告的产品缺陷、采取纠正措施并改进下一代产品。各机构可以改进对法规的遵守，提高客户满意度和节省数百万美元的保修和服务成本。"
      :tabList="tabList3"
    ></TabManagement>
    <TabManagement
      isLeft
      title="4、研发成本管理平台"
      description="Agile Product Cost Management 有助于企业在所售产品的整个生命周期内优化其战略性采购寻源流程。该软件是独一无二的企业间协作解决方案，它可将供应商的特定成本和风险数据与企业的产品记录（完整且最新的定义产品）合并起来，并对设计和采购寻源人员、客户、供应商以及制造商输入的数据进行整合。通过基于从内部机构或外部各级制造商和供应商获得的数据进行物料清单(BOM)采购寻源分析，Agile产品成本管理软件可提供产品生命周期的综合视图，借助该视图，企业能够前瞻性地分析和调整各流程，以最大限度地降低成本和风险。"
      :tabList="tabList4"
    ></TabManagement>
    <TabManagement
      title="5、企业可视化"
      description="企业可视化解决方案 AutoVue套件不仅提供对原始文档查看，标注和实时协作功能，同时它能够基于网页对上百种文件格式进行浏览并保持文件的安全性和准确性。"
      :tabList="tabList5"
    ></TabManagement>
    <TabManagement
      title="6、系统集成平台"
      description="Agile Engineering Collaboration提供一个在产品生命周期最开端的工程设计流程自动化。该模块提供了产品数据的紧密结合，并提供一个直接从设计工具存取产品数据的对话式接口。"
      :tabList="tabList6"
    ></TabManagement>
    <PointOfPain 
      ref="characteristic"
      :listData="listData" 
      title="多层级多角色协同应用"
      description="植根于用户需求，不断快速迭代升级"
    />
    <SystemFunction
      class="typical-user"
      :systemInfo="systemInfo2"
    ></SystemFunction>
    <ChooseUs :nameVals="['electron', 'OracleAgile']" :scrollNum="2"></ChooseUs>
    <custom-form 
      ref="customForm"
      title="更好用的 Oracle Agile PLM 产品"
    />
    <footer-box />
  </div>
</template>

<script>
import SRMHeader from "@/components/SRMHeader/index";
import CarouselContainer from "@/components/CarouselContainer/single"
import OracleDesc from "@/components/OracleDesc"
import ValueGain from "@/components/ValueGain"
import ProblemSolving from "@/components/ProblemSolving"
import SystemFunction from "@/components/SystemFunction"
import TabManagement from "@/components/TabManagement"
import PointOfPain from "@/components/PointOfPain/index"
import CustomForm from "@/components/Form"
import FooterBox from "@/components/FooterBox"
import ChooseUs from "@/components/ChooseUs"
import { baiduConsult } from "./common.js";

import hgs3 from '@/assets/images/hgs3.png'

import gnt2 from '@/assets/images/gnt2.png'
import gnt3 from '@/assets/images/gnt3.png'

import xt1 from '@/assets/images/xt1.png'
import xt2 from '@/assets/images/xt2.png'
import xt3 from '@/assets/images/xt3.png'

import tycp1 from '@/assets/images/tycp1.png'
import tycp2 from '@/assets/images/tycp2.png'
import tycp3 from '@/assets/images/tycp3.png'
import tycp4 from '@/assets/images/tycp4.png'

import yfzl1 from '@/assets/images/yfzl1.png'
import yfzl2 from '@/assets/images/yfzl2.png'

import yfcb1 from '@/assets/images/yfcb1.png'
import yfcb2 from '@/assets/images/yfcb2.png'

import qyksh1 from '@/assets/images/qyksh1.png'
import qyksh2 from '@/assets/images/qyksh2.png'

import xtjc1 from '@/assets/images/xtjc1.png'
import xtjc2 from '@/assets/images/xtjc2.png'

export default {
  components: {
    SRMHeader,
    CarouselContainer,
    OracleDesc,
    ValueGain,
    ProblemSolving,
    SystemFunction,
    TabManagement,
    PointOfPain,
    ChooseUs,
    CustomForm,
    FooterBox,
  },
  metaInfo() {
    return {
      title: '璞华易研 - 企业级PLM&PMS解决方案',
      meta: [
        {
          name: 'keywords',
          content: '璞华易研,PLM,PMS,PDM,产品生命周期管理,研发项目管理,国产PLM,智能制造'
        },
        {
          name: 'description',
          content: '璞华官方热线：4006-160-730。璞华易研PLM&PMS，帮助客户高效实现产品生命周期管理和研发项目管理，在流程行业、医疗器械、芯片半导体、电子高科技、机械制造等方面拥有丰富的案例。'
        }
      ]
    }
  },
  data() {
    return {
      systemInfo: {
        title: 'Oracle Agile PLM的系统功能图',
        description: 'Oracle Agile PLM方案套件包括项目管理、成本管理、质量管理、研发及工程协同、产品协同、跨部门可视化以及合规管理等核心功能。下面是系统功能图',
        img: gnt2,
      },
      systemInfo2: {
        title: 'Oracle Agile PLM有哪些典型用户？',
        description: '以卓越赢得信任，以口碑畅行天下',
        img: gnt3,
      },
      carouselInfo: {
        title: 'Oracle Agile PLM',
        description: '协同研发的产品生命周期管理平台，敏捷以致远！',
        bg: hgs3
      },
      listData: [
        {
          num: '01',
          title: '功能全面',
          contentList: [
            {
              content: 'Oracle Agile PLM是成熟的企业级的PLM解决方案，除了满足最基本的是数据管理及项目管理之外，产品还提供需求管理、质量管理、合规管理等功能，全方位的提升企业研发能力'
            }
          ]
        },
        {
          num: '02',
          title: '易于集成',
          contentList: [
            {
              content: 'Oracle Agile PLM拥有整体统一而且开放的技术架构，可以根据客户的实际需要进行拓展，能与各种设计工具和常用的ERP、SRM、CRM等业务系统进行深度集成，实现系统融合'
            }
          ]
        },
        {
          num: '03',
          title: '案例众多',
          contentList: [
            {
              content: 'Oracle Agile PLM是业界广泛使用的具有行业针对性的PLM产品，在全球拥有丰富的使用案例，各行业都有龙头企业选择此产品：苹果、富士康、比亚迪、拜耳制药、强生医疗等等'
            }
          ]
        },
        {
          num: '04',
          title: '维护方便',
          contentList: [
            {
              content: 'Oracle Agile PLM是一款轻量级的配置化的平台软件，关注用户体验，给用户带来了无与伦比的易用性和维护便利性，系统功能更改可快速配置，可以满足企业不断变化的业务需求'
            }
          ]
        }
      ],
      tabList1: [
        {
          name: 'first',
          label: '研发资源管理',
          num: '01',
          img: xt1,
          description: '合理分配项目各种资源，实时动态管理项目资源，实现项目资源及时有效管理， 提高项目资源利用率。'
        },
        {
          name: 'second',
          label: '研发进度管理',
          num: '02',
          img: xt2,
          description: '根据项目进度目标，提供高效的管理平台，实时监控执行项目整体过程，提高项目执行效率。'
        },
        {
          name: 'third',
          label: '项目协同管理',
          num: '03',
          img: xt3,
          description: '提供协同项目管理平台，以多维度、多部门管理项目产出物， 整体控制项目执行过程中的交付文件、财务数据、组织结构数据。'
        },
      ],
      tabList2: [
        {
          name: 'first',
          label: '产品物料管理',
          num: '01',
          img: tycp1,
          description: '建立企业级的标准物料库和零部件库，实现产品物料的快速选配； 基于行业标准进行物料分类，统一的编码和属性描述体系，完善闭环的物料管理流程。'
        },
        {
          name: 'second',
          label: '产品结构管理',
          num: '02',
          img: tycp2,
          description: '产品结构管理是建立在企业已有规范的、完备定义的产品、零部件族模型的基础上， 通过建立产品、零部件族内在的配置规则，利用零部件之间参数与条件相互约束的关系， 经过规则运算后得出符合条件的产品BOM结构和相应的零部件。'
        },
        {
          name: 'third',
          label: '产品变更管理',
          num: '03',
          img: tycp3,
          description: '支持CMII管理规范，贯彻严谨规范的设计变更管理理念，涵盖从问题报告、变更请求、 变更通知、变更操作实施的全过程应用。 通过严谨规范的评审流程组织更改各种变更对象的受控资料（如图纸、技术文档、产品BOM、物料等）。'
        },
        {
          name: 'four',
          label: '文档管理',
          num: '04',
          img: tycp4,
          descArr: [
            {
              name: '文档分类版本管理',
              content: '以复合分类法对产品相关的图文档进行分类，规定 与物料相关的文档类，标准规范类文档及软件标签等，这样业务人 员可以通过统一平台快速查找到相关信息，在很大程度上提高工作效率。'
            },
            {
              name: '文档协同管理',
              content: '根据文档类别组织、共享、使用和采用文控体系要求的规则进行管理， 被授予权限的用户可以方便地查阅、借用、修改、发布、归档这些文档。'
            },
            {
              name: '产品知识管理',
              content: '记录产品研发文档，统一知识管理平台，降低因人员流失而给企业造成的智慧财产损失。'
            }
          ]
        },
      ],
      tabList3: [
        {
          name: 'first',
          label: '闭环的质量问题管理',
          num: '01',
          img: yfzl1,
          description: '在产品质量问题解决方案中，内嵌了基于质量问题管理的不合格材料报告（NCMR）以及CAPA与FMEA处理流程，实现了企业对产品质量问题闭环的管理方式。 通过产品质量库及产品质量标准库的建立， 可以帮助企业在加速产品设计的同时保证产品设计质量及可靠性。'
        },
        {
          name: 'second',
          label: '质量问题库及分析',
          num: '02',
          img: yfzl2,
          description: '产品质量管理支持企业在产品全生命周期过程中对产品质量的监控、产品问题的分析与解决，提高产品在设计及生产过程中的质量及可靠性。通过系统对质量事件进行跟踪，提供质量信息的可视化分析工具，并对质量问题进行预防。'
        }
      ],
      tabList4: [
        {
          name: 'first',
          label: '供应商在线报价',
          num: '01',
          img: yfcb1,
          description: '将成本和采购寻源数据整合到一个安全的产品记录中。支持设计和采购寻源人员、供应商以及制造商协作输入数据。'
        },
        {
          name: 'second',
          label: '成本比较',
          num: '02',
          img: yfcb2,
          description: '模拟和分析商品化的零部件、设计的零部件以及产品的成本情况，利用强大的分析功能将实际成本与目标成本进行评测对比。'
        }
      ],
      tabList5: [
        {
          name: 'first',
          label: '图纸可视化',
          num: '01',
          img: qyksh1,
          description: '无需原设计工具的许可证即可进行浏览及标注；与企业内部各部门, 外协厂及供应链进行实时共享；与产品数据管理平台完全集成；实现无纸化电子流程。'
        },
        {
          name: 'second',
          label: '广泛支持各种文件格式',
          num: '02',
          img: qyksh2,
          description: '企业可视化解决方案 AutoVue可支持主流的500多种格式文件的在线查看、批注等功能，大大降低设计工具购买费用。'
        }
      ],
      tabList6: [
        {
          name: 'first',
          label: '设计工具集成',
          num: '01',
          img: xtjc1,
          description: '实现统一的元器件库，同时也支持从设计图纸中自动提取信息产生BOM，快速生成电子产品的各类BOM表（PBOM，MBOM）。'
        },
        {
          name: 'second',
          label: '企业系统集成',
          num: '02',
          img: xtjc2,
          description: '集成化产品开发（IPD）体系以PLM为支撑，同CRM、ERP、MES、CAD、SCM等系统，共同构建协同产品设计与数据管理平台，各系统之间形成业务流程与数据交互的环境。'
        }
      ],
    }
  },
  mounted() {
    baiduConsult();
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/mixins.scss";

.oracle-agile {
  ::v-deep .srm-header {
    padding-right: 8rem;
  }
  ::v-deep .productfeature .tab-container .el-tabs .el-tabs__header .el-tabs__nav .el-tabs__item {
    width: 28rem;
  }
  ::v-deep .systemFunction-container {
    background: linear-gradient( 168deg, #FBFCFD 0%, #F4F7F9 100%);
  }
  ::v-deep .point-of-pain {
    .point-of-pain-title {
      padding: 10rem 0 2.4rem !important;
    }
    .point-of-pain-description {
      padding-bottom: 6.2rem !important;
    }
    .list-item {
      padding: 5.6rem 5.2rem 0rem 4.8rem !important;
      height: 24.6rem !important;
      .cl-list {
        margin-top: 3rem !important;
      }
      .cl-l-i-content {
        padding-left: 0 !important;
        &::before {
          border: none !important;
        }
      }
    }
  }
  .typical-user {
    ::v-deep .systemFunction-list {
      height: 55.2rem;
    }
  }
  ::v-deep .productfeature {
    .content-left {
      padding: 0;
      left: 26rem;
      width: 54rem;
    }
    .content-right {
      width: 88.2rem;
      height: 51rem;
      top: 12.7rem;
      right: 17.1rem;
    }
  }

  @include mobile-page-overrides;
}
</style>
